export default {
  beforeRouteLeave(to, from, next) {
    let routesToSkip = [
      'AddressesView',
      'OrderHistoryView',
      'PreferencesView',
      'ExternalLinksView',
      'ManageCardsView',
      'GiftCardsView',
      'RewardsView',
      'FavoriteItemsView',
      'PasswordResetView',
      'OrderQuoteView',
      'CheckInView',
      'NotFoundView',
    ]
    if (routesToSkip.includes(to.name)) {
      next()
      return
    }
    let route = {
      name: from.name,
      path: from.path,
    }
    localStorage.setItem('backToRoute', JSON.stringify(route))
    next()
  },
}
